import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _JSXStyle from "styled-jsx/style";
import React from 'react';
import withDefaults from '../utils/with-defaults';
var defaultProps = {
  center: false,
  className: ''
};

var PageHeader = function PageHeader(_ref) {
  var children = _ref.children,
      center = _ref.center,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["children", "center", "className"]);

  return (
    /*#__PURE__*/
    React.createElement("header", _extends({}, props, {
      className: "jsx-2933443918" + " " + (props && props.className != null && props.className || "".concat(center ? 'center' : '', " ").concat(className))
    }), children,
    /*#__PURE__*/
    React.createElement(_JSXStyle, {
      id: "2933443918"
    }, "header.jsx-2933443918{width:100%;}.center.jsx-2933443918{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}"))
  );
};

export default withDefaults(PageHeader, defaultProps);